/**
 * UrbanismePresencePage — onglet Présence du module Urbanisme (présence seule,
 * sans affectation de tâches). Réutilise le composant partagé PresenceSimplePage.
 */
import { api } from '@/lib/api';
import { UrbanismeLayout } from '@/components/UrbanismeLayout';
import { PresenceSimplePage } from '@/pages/shared/PresenceSimplePage';

export function UrbanismePresencePage() {
  return (
    <UrbanismeLayout active="presence">
      <PresenceSimplePage planningApi={api.urbanisme.planning} accent="urbanisme" service="urbanisme" />
    </UrbanismeLayout>
  );
}
